export default __webpack_public_path__ + "static/media/greeneye-logo.109495bc.svg";